import React, { useEffect, useState } from "react";

import { BrowserRouter, Outlet, useLocation, useNavigate } from "react-router-dom";

import { Box, Chip, IconButton, Stack } from "@mui/material";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepButton from "@mui/material/StepButton";
import { useSelector, Provider } from "react-redux";
import store from "../Components copy/redux/store";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../Components copy/ThemeProvider/ThemeProvider";
import { styled } from "@mui/material/styles";

import { StepIconProps } from "@mui/material/StepIcon";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";

import Check from "@mui/icons-material/Check";
import AppStyles from "../App.module.scss";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import backIcon from "../Components copy/assets/Images/backIcon.svg";

import { stageDetailsAPICall } from "../shared copy/APICalls";
import routesData from "../shared copy/routes.json";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 3,
  borderRadius: 5,
  margin: "0px 0px 0px 0px",
  // width: "93vw",
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#B1DDC3" : "#308fe8",
  },
}));

interface Props {
  completedStages: any;
  stageName: string;
  navigatePath: string;
  esignBackButtonEnable?: any;
}

export default function StageLayout({
  completedStages,
  stageName,
  navigatePath,
  esignBackButtonEnable,
}: Props) {
  //console.log("completedStages", completedStages);

  const navigate = useNavigate();

  const [step, setStep] = useState<any>(1);
  const [stageDetailsApi, setStageDetailsApi] = useState<any>(0);
  const [showSteps, setshowSteps] = useState(false);
  const navigationData = routesData;
  const pathName = useLocation().pathname;
  //console.log(pathName);

  const pathToStepMap = {
    "/": -4,
    "/confirm_otp": -3,
    "/yourdetails": -2,
    "/confirmemailotp": -1,
    "/panverification": 1,
    "/aadhaarkyc": 2,
    "/tradingPreference": 3,
    "/yourprofile": 4,
    "/linkusingifsc": 5,
    "/cameramodule": 6,
    "/uploaddocuments": 7,
    "/generatePartnerCode": 8,
    "/termsandconditions": 9,
    "/esign": 10,
    "/congratulations": 11,
    "/support": 12,
  };

  const completed = {
    pan_details: 0,
    fetch_details: 1,
    segment_details: 2,
    profile_page: 3,
    bank_account: 4,
    web_image: 5,
    document_upload: 6,
    code_generation: 7,
    t_and_c: 8,
    e_sign: 9,
    application_completed: 10,
    support_contact: 11,
  };

  useEffect(() => {
    Object.keys(pathToStepMap).forEach((path) => {
      if (pathName.includes(path)) {
        //  setStep(pathToStepMap[path]);
        setStageDetailsApi(pathToStepMap[path]);
        //console.log(pathToStepMap[path]);
      }
    });
  }, [pathName]);

  useEffect(() => {
    if (stageDetailsApi > 0) {
      if (completedStages) {
        const matchedRoutes: any = [];
        completedStages.forEach((route) => {
          if (completed.hasOwnProperty(route)) {
            matchedRoutes.push(completed[route]);
          }

          setStep(matchedRoutes.length);
        });
      }
    }
  }, [stageDetailsApi, completedStages]);

  useEffect(() => {
    if (stageDetailsApi > -1) {
      setshowSteps(true);
    }
  }, [step]);

  const handleClick = (index) => {
    // console.log("path", index);

    if (index <= step) {
      const path = Object.keys(pathToStepMap).find(
        (key) => pathToStepMap[key] === index + 1
      );
      if (path) {
        // window.location.href = path;
        navigate(path);
      }
    }
  };

  const handleBackClick = () => {
    if (pathName.includes("cameramodule")) {
      window.location.href = navigatePath;
    } else {
      navigate(navigatePath);
    }
  };

  const steps = [
    "Pan",
    "Aadhaar",
    "Trading",
    "Profile",
    "Bank",
    "Cam",
    "Documents",
    "Nominee",
    "T&C",
    "Esign",
  ];

  const stepMobile = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
  return (
    <>
      <Stack style={{ overflowX: "hidden" }}>
        {showSteps && (
          <>
            {step >= 0 && step <= 9 && (
              <>
                <Box
                  sx={{
                    width: { xs: "99%", md: "98%" },
                    margin: { xs: "0 2px", md: "0 10px" },
                    zIndex: 100,
                    // position: "fixed",
                  }}
                >
                  <Box sx={{ flexGrow: 1 }}>
                    <BorderLinearProgress
                      variant="determinate"
                      value={pathName.includes("support")? 9.1 * 11 : step * 12.5}
                    />
                  </Box>
                </Box>
                <Stack alignItems={"flex-start"}>
                  <div style={{ marginTop: "5px", marginLeft: "3%" }}>
                    {pathName.includes("panverification") ||
                    pathName.includes("aadhaar") ||
                    pathName.includes("yourprofile") ||
                    pathName.includes("support") ||
                    esignBackButtonEnable === "DocumentReceived" ? (
                      ""
                    ) : (
                      <IconButton onClick={handleBackClick}>
                        <img src={backIcon} style={{ background: "white" }} />
                      </IconButton>
                    )}
                    <Chip
                      sx={{
                        border: "1px solid #006779",
                        backgroundColor: "#CCE1E4",
                        marginTop:
                          pathName.includes("panverification") ||
                          pathName.includes("aadhaar") ||
                          pathName.includes("yourprofile") ||
                          pathName.includes("support") ||
                          esignBackButtonEnable === "DocumentReceived"
                            ? "5px"
                            : 0,
                      }}
                      label={stageName}
                      variant="outlined"
                    />
                  </div>
                </Stack>
              </>
            )}
          </>
        )}
      </Stack>
    </>
  );
}
